// extracted by mini-css-extract-plugin
export default {"content":"HeroSection_content__olJil","logos":"HeroSection_logos__LTitL","moveLogos":"HeroSection_moveLogos__T0MmF","logo-container":"HeroSection_logo-container__N0MTF"};